export default interface IAction{
    type: string,
    payload?: any
}

export const Actions = {
    ADD_USER: 'ADD_USER',
    CHOOSE_DOCUMENT: 'CHOOSE_DOCUMENT',
    SAVE_SOCIETE: 'SAVE_SOCIETE',
}


// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/services/state/actions.ts